import imagesDefault from './imagesDefault';
import imagesRenaissance from './imagesRenaissance';

const IMAGE = process.env.REACT_APP_SP_NAME === 'renaissance'
    ? imagesRenaissance
    : imagesDefault;

export default IMAGE;
